import _ from 'lodash';
import BusinessLocation from './BusinessLocation';
import BusinessImage from './BusinessImage';

export default class PaginationResult {
    constructor(json, Type) {
        this.count = json.count;
        this.results = json.results.map(data => new Type(data));
    }
}